// @flow
export const MODEL = 'Grid'
export const URL = 'hefty/grid/'

// Model Attributes
export const PROP_ID = 'id'
export const PROP_GRID = 'grid'
export const PROP_SOIL_JOB = 'job'

// Unit Choices
export const GRID_UNIT_ACRES = 'acres'
export const GRID_UNIT_HECTARES = 'hectares'
export const GRID_UNIT_MILES = 'miles'
export const GRID_UNIT_KILOMETERS = 'kilometers'

export const GRID_UNIT_CHOICES = [
  GRID_UNIT_ACRES,
  GRID_UNIT_HECTARES,
]

export const SCHEMA = [{
  id: PROP_ID,
  grid: PROP_GRID,
  job: PROP_SOIL_JOB,
}]
